// extracted by mini-css-extract-plugin
export default {"tabContainer":"PropertyTab_tabContainer__NR9o7","tab":"PropertyTab_tab__yjZ0R","selectedTab":"PropertyTab_selectedTab__FN+WY"};